export const serviceProviderUnitOverviewAreaPathName = 'enhedsoverblik';
